
import dayjs from 'dayjs'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
@Component
export default class CountDown extends Vue {
  @Prop({ default: 1 }) type!: number // 1：详情页倒计时 2：活动页倒计时 3：首页
  @Prop({ default: '2024/6/14 18:30:00' }) times!: string
  @Prop({ default: false }) isAdvance!: boolean
  date = 0

  getZero (num: any) {
    if (num < 10) { return '0' + num }
    return num
  }

  @Watch('times', {immediate: true})
  handleDate () {
    let date = dayjs(this.times).format('YYYY/MM/DD HH:mm:ss')
    this.date = new Date(date).getTime() - new Date().getTime()
    console.log('this date ***', this.date)
  }

  // 倒计时结束时触发方法
  finishFn () {
    console.log('CountDown end ***')
    this.$emit('end')
  }
}
